<script setup lang="ts">
import { Icon } from '@collector/shared-ui'

type Props = {
  status: 'pending' | 'success' | 'error'
}

defineProps<Props>()
</script>

<template>
  <div class="ml-auto flex h-4 w-4">
    <Icon
      v-if="status === 'pending'"
      class="animate-spin"
      icon="rotate-right"
      size="lg"
    />
    <Icon
      v-if="status === 'success'"
      icon="check"
      size="lg"
    />
    <Icon
      v-if="status === 'error'"
      class="text-error-5"
      icon="warning"
      size="lg"
    />
  </div>
</template>
